import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as featuresAPI from 'api/Settings/features';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';

const initalState = {
  pageSize: 10,
  currentPage: 1,
  allRolesData: null,
  allPagesData: null,
  allPageComponentsData: null,
  allMetaDataFields: null,
  page: {
    data: null,
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Slug', key: 'slug', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Group', key: 'group', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 120 },
      { title: 'Status', key: 'status', type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Created_AT', key: 'created_at', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 120 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  },
  pageComponent: {
    data: null,
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Slug', key: 'slug', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Group', key: 'group', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 120 },
      { title: 'Status', key: 'status', type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Page', key: 'page', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 120 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  },
  componentFeature: {
    data: null,
    allPagesData: null,
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Slug', key: 'slug', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Group', key: 'group', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 120 },
      { title: 'Page', key: 'page', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 120 },
      { title: 'Status', key: 'status', type: TYPE_OF_FIELD_IN_COLUMN.STATUS, width: 120 },
      { title: 'Component', key: 'frontend_page_component', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Filter Type', key: 'filter_type', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Meta Data Field', key: 'meta_data_field', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Is Predefined Value', key: 'is_predefined_value', type: TYPE_OF_FIELD_IN_COLUMN.BOOLEAN, width: 210 },
      { title: 'Value', key: 'value', type: TYPE_OF_FIELD_IN_COLUMN.ARRAY, width: 210 },
      { title: 'Priority Index', key: 'priority_index', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 210 },
      { title: 'Created-AT', key: 'created_at', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 210 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  }
};

const getFeaturesPageData = createAsyncThunk('settings/features/readPage', async (filter) => {
  const res = await featuresAPI.getFeaturesPageData(filter);
  return res.data?.data;
});

const getAllRolesData = createAsyncThunk('settings/features/getAllRoles', async () => {
  const res = await featuresAPI.getAllRolesData();
  return res.data?.data;
});

const updateFeaturePage = createAsyncThunk('settings/features/updatePage', async (params) => {
  const res = await featuresAPI.updateFeaturePage(params);
  return res.data?.data;
});

const getPageComponentData = createAsyncThunk('settings/features/pageComponent', async (filter) => {
  const res = await featuresAPI.getPageComponentData(filter);
  return res.data?.data;
});

const getAllPages = createAsyncThunk('settings/features/getAllPages', async () => {
  const res = await featuresAPI.getAllPages();
  return res.data?.data;
});

const updatePageComponent = createAsyncThunk('settings/features/updatePageComponent', async (params) => {
  const res = await featuresAPI.updatePageComponent(params);
  return res.data?.data;
});

const getComponentFeaturesData = createAsyncThunk('settings/features/componentFeature', async (filter) => {
  const res = await featuresAPI.getComponentFeaturesData(filter);
  return res.data?.data;
});

const getAllPageComponents = createAsyncThunk('settings/features/getAllPageComponents', async () => {
  const res = await featuresAPI.getAllPageComponents();
  return res.data?.data;
});

const getAllMetaDataFields = createAsyncThunk('settings/features/getAllMetaDataFields', async () => {
  const res = await featuresAPI.getAllMetaDataFields();
  return res.data?.data;
});

const updateComponentFeature = createAsyncThunk('settings/features/updateComponentFeature', async (params) => {
  const res = await featuresAPI.updateComponentFeature(params);
  return res.data?.data;
});

const createComponentFeature = createAsyncThunk('settings/features/createComponentFeature', async (params) => {
  const res = await featuresAPI.createComponentFeature(params);
  return res.data?.data;
});

const deleteComponentFeature = createAsyncThunk('settings/features/deleteComponentFeature', async (id) => {
  const res = await featuresAPI.deleteComponentFeature(id);
  return res.data?.data;
});

const features = createSlice({
  name: 'features',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    }
  },
  extraReducers: {
    [getAllRolesData.fulfilled]: (state, action) => {
      state.allRolesData = action.payload;
    },

    [getAllPages.fulfilled]: (state, action) => {
      state.allPagesData = action.payload;
    },

    [getAllPageComponents.fulfilled]: (state, action) => {
      state.allPageComponentsData = action.payload;
    },

    [getAllMetaDataFields.fulfilled]: (state, action) => {
      state.allMetaDataFields = action.payload;
    },

    [getFeaturesPageData.pending]: (state) => {
      state.page.status = 'init';
      state.page.ui.loading = true;
    },

    [getFeaturesPageData.fulfilled]: (state, action) => {
      state.page.status = 'idle';
      state.page.ui.loading = false;
      state.page.data = action.payload.results;
      state.page.totalRecords = action.payload.count;
    },

    [getFeaturesPageData.rejected]: (state, action) => {
      state.page.status = 'error';
      state.page.error = action.error.message;
      state.page.ui.loading = false;
    },

    [updateFeaturePage.pending]: (state) => {
      state.page.status = 'init';
      state.page.ui.loading = true;
    },

    [updateFeaturePage.fulfilled]: (state, action) => {
      state.page.status = 'idle';
      state.page.ui.loading = false;
      const updatedData = state.page.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.page.data = updatedData;
    },

    [updateFeaturePage.rejected]: (state, action) => {
      state.page.status = 'error';
      state.page.error = action.error.message;
      state.page.ui.loading = false;
    },

    [getPageComponentData.pending]: (state) => {
      state.pageComponent.status = 'init';
      state.pageComponent.ui.loading = true;
    },

    [getPageComponentData.fulfilled]: (state, action) => {
      state.pageComponent.status = 'idle';
      state.pageComponent.ui.loading = false;
      state.pageComponent.data = action.payload.results;
      state.pageComponent.totalRecords = action.payload.count;
    },

    [getPageComponentData.rejected]: (state, action) => {
      state.pageComponent.status = 'error';
      state.pageComponent.error = action.error.message;
      state.pageComponent.ui.loading = false;
    },

    [updatePageComponent.pending]: (state) => {
      state.pageComponent.status = 'init';
      state.pageComponent.ui.loading = true;
    },

    [updatePageComponent.fulfilled]: (state, action) => {
      state.pageComponent.status = 'idle';
      state.pageComponent.ui.loading = false;
      const updatedData = state.pageComponent.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.pageComponent.data = updatedData;
    },

    [updatePageComponent.rejected]: (state, action) => {
      state.pageComponent.status = 'error';
      state.pageComponent.error = action.error.message;
      state.pageComponent.ui.loading = false;
    },

    [getComponentFeaturesData.pending]: (state) => {
      state.componentFeature.status = 'init';
      state.componentFeature.ui.loading = true;
    },

    [getComponentFeaturesData.fulfilled]: (state, action) => {
      state.componentFeature.status = 'idle';
      state.componentFeature.ui.loading = false;
      state.componentFeature.data = action.payload.results;
      state.componentFeature.totalRecords = action.payload.count;
    },

    [getComponentFeaturesData.rejected]: (state, action) => {
      state.componentFeature.status = 'error';
      state.componentFeature.error = action.error.message;
      state.componentFeature.ui.loading = false;
    },

    [updateComponentFeature.pending]: (state) => {
      state.componentFeature.status = 'init';
      state.componentFeature.ui.loading = true;
    },

    [updateComponentFeature.fulfilled]: (state, action) => {
      state.componentFeature.status = 'idle';
      state.componentFeature.ui.loading = false;
      const updatedData = state.componentFeature.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        }
        return item;
      });
      state.componentFeature.data = updatedData;
    },

    [updateComponentFeature.rejected]: (state, action) => {
      state.componentFeature.status = 'error';
      state.componentFeature.error = action.error.message;
      state.componentFeature.ui.loading = false;
    },

    [createComponentFeature.pending]: (state) => {
      state.componentFeature.status = 'init';
      state.componentFeature.ui.loading = true;
    },

    [createComponentFeature.fulfilled]: (state) => {
      state.componentFeature.status = 'idle';
      state.componentFeature.ui.loading = false;
    },

    [createComponentFeature.rejected]: (state, action) => {
      state.componentFeature.status = 'error';
      state.componentFeature.error = action.error.message;
      state.componentFeature.ui.loading = false;
    },

    [deleteComponentFeature.pending]: (state) => {
      state.componentFeature.status = 'init';
      state.componentFeature.ui.loading = true;
    },

    [deleteComponentFeature.fulfilled]: (state) => {
      state.componentFeature.status = 'idle';
      state.componentFeature.ui.loading = false;
    },

    [deleteComponentFeature.rejected]: (state, action) => {
      state.componentFeature.status = 'error';
      state.componentFeature.error = action.error.message;
      state.componentFeature.ui.loading = false;
    }
  }
});

export const { setCurrentPage, setPageSize } = features.actions;

export default features.reducer;

export {
  getFeaturesPageData,
  getAllRolesData,
  updateFeaturePage,
  getPageComponentData,
  getAllPages,
  getAllPageComponents,
  getAllMetaDataFields,
  updatePageComponent,
  getComponentFeaturesData,
  updateComponentFeature,
  createComponentFeature,
  deleteComponentFeature
};
